import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "react-js-pagination";
import moment from "moment";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { UncontrolledTooltip } from "reactstrap";
import debounce from "debounce-promise";

class Carteira extends Component {
  constructor() {
    super();
    this.toggleAba = this.toggleAba.bind(this);
    this.load = this.load.bind(this);
    this.loadClientesAtendidos = this.loadClientesAtendidos.bind(this);
    this.paginarAtendidos = this.paginarAtendidos.bind(this);
    this.paginarNaoAtendidos = this.paginarNaoAtendidos.bind(this);
    this.loadClientesNaoAtendidos = this.loadClientesNaoAtendidos.bind(this);

    this.paginarCriticos = this.paginarCriticos.bind(this);
    this.loadClientesCriticos = this.loadClientesCriticos.bind(this);
    this.promiseOptions = this.promiseOptions.bind(this);
    this.transformDataComboBoxCliente =
      this.transformDataComboBoxCliente.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.abrirDetalheCliente = this.abrirDetalheCliente.bind(this);
    this.loadCidadesCarteira = this.loadCidadesCarteira.bind(this);
    this.loadClientesCidade = this.loadClientesCidade.bind(this);

    this.debouncedLoadOptions = debounce(
      (inputValue) => this.promiseOptions(inputValue),
      500,
      {
        leading: true,
      }
    );


    this.state = {
      abaAtiva: "atendidos", //atendidos, naoAtendidos, criticos, clientesCidade
      clientesAtendidos: [],
      clientesAtendidosBkp: [],
      paginacaoClientesAtendidos: {
        pagina: 1,
        limite: 10,
      },
      totalizadorClientesAtendidos: 0,

      clientesNaoAtendidos: [],
      clientesNaoAtendidosBkp: [],
      paginacaoClientesNaoAtendidos: {
        pagina: 1,
        limite: 10,
      },
      totalizadorClientesNaoAtendidos: 0,
      carregarClientesNaoAtendidos: true,

      clientesCriticos: [],
      clientesCriticosBkp: [],
      paginacaoClientesCriticos: {
        pagina: 1,
        limite: 10,
      },
      totalizadorClientesCriticos: 0,
      carregarClientesCriticos: true,
      listaClientes: [],
      clienteSelecionado: null,
      listaCidades: [],
      cidadeselecionada: null,
      listaClientesCidade: [],
    };
  }

  async componentDidMount() {
    await this.load();
    await this.loadCidadesCarteira();
  }

  async loadClientesAtendidos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/atendidos`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState(
          {
            clientesAtendidosBkp: response.data.pedidos,
            totalizadorClientesAtendidos: response.data.pedidos.length,
          },
          () => {
            this.paginarAtendidos(1);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadClientesNaoAtendidos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/nao-atendidos`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState(
          {
            clientesNaoAtendidosBkp: response.data.pedidos,
            totalizadorClientesNaoAtendidos: response.data.pedidos.length,
            carregarClientesNaoAtendidos: false,
          },
          () => {
            this.paginarNaoAtendidos(1);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadClientesCriticos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/criticos`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState(
          {
            clientesCriticosBkp: response.data.clientes,
            totalizadorClientesCriticos: response.data.clientes.length,
            carregarClientesCriticos: false,
          },
          () => {
            this.paginarCriticos(1);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async load() {
    await this.loadClientesAtendidos();
  }

  toggleAba(abaAlterar) {
    this.setState({ abaAtiva: abaAlterar }, () => {
      if (
        abaAlterar === "naoAtendidos" &&
        this.state.carregarClientesNaoAtendidos
      ) {
        this.loadClientesNaoAtendidos();
      } else if (
        abaAlterar === "criticos" &&
        this.state.carregarClientesCriticos
      ) {
        this.loadClientesCriticos();
      }
    });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  paginarAtendidos(paginaAlterar) {
    this.setState(
      { paginacaoClientesAtendidos: { pagina: paginaAlterar, limite: 10 } },
      () => {
        let clientes = [...this.state.clientesAtendidosBkp];

        paginaAlterar = paginaAlterar - 1;
        clientes = clientes.slice(
          paginaAlterar * this.state.paginacaoClientesAtendidos.limite,
          (paginaAlterar + 1) * this.state.paginacaoClientesAtendidos.limite
        );

        paginaAlterar = paginaAlterar + 1;

        this.setState({ clientesAtendidos: clientes });
      }
    );
  }

  paginarNaoAtendidos(paginaAlterar) {
    this.setState(
      { paginacaoClientesNaoAtendidos: { pagina: paginaAlterar, limite: 10 } },
      () => {
        let clientes = [...this.state.clientesNaoAtendidosBkp];

        paginaAlterar = paginaAlterar - 1;
        clientes = clientes.slice(
          paginaAlterar * this.state.paginacaoClientesNaoAtendidos.limite,
          (paginaAlterar + 1) * this.state.paginacaoClientesNaoAtendidos.limite
        );

        paginaAlterar = paginaAlterar + 1;

        this.setState({ clientesNaoAtendidos: clientes });
      }
    );
  }

  paginarCriticos(paginaAlterar) {
    this.setState(
      { paginacaoClientesCriticos: { pagina: paginaAlterar, limite: 10 } },
      () => {
        let clientes = [...this.state.clientesCriticosBkp];

        paginaAlterar = paginaAlterar - 1;
        clientes = clientes.slice(
          paginaAlterar * this.state.paginacaoClientesCriticos.limite,
          (paginaAlterar + 1) * this.state.paginacaoClientesCriticos.limite
        );

        paginaAlterar = paginaAlterar + 1;

        this.setState({ clientesCriticos: clientes });
      }
    );
  }

  promiseOptions(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          resolve([])
          // await axios
          //   .get(
          //     `${this.props.getBaseUrlApi()}/clientes/lista?limite=5`,
          //     this.props.parameters()
          //   )
          //   .then((response) => {
          //     this.setState(
          //       {
          //         listaClientes: this.transformDataComboBoxCliente(
          //           response.data.clientes
          //         ),
          //       },
          //       () => {
          //         resolve(this.state.listaClientes);
          //       }
          //     );
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //     if (error.response !== undefined) {
          //       if (error.response.status === 401) {
          //         this.props.logout();
          //       }
          //       if (error.response.status === 403) {
          //         this.props.history.push('/home')
          //       }
          //     }
          //   })
        } else {
          if (inputValue.length >= 3) {
            await axios
              .get(
                `${this.props.getBaseUrlApi()}/clientes/busca?desc=${inputValue}`,
                this.props.parameters()
              )
              .then((response) => {
                this.setState(
                  {
                    listaClientes: this.transformDataComboBoxCliente(
                      response.data.clientes
                    ),
                  },
                  () => {
                    resolve(this.state.listaClientes);
                  }
                );
              })
              .catch((error) => {
                console.log(error);
                if (error.response !== undefined) {
                  if (error.response.status === 401) {
                    this.props.logout();
                  }
                  if (error.response.status === 403) {
                    this.props.history.push('/home')
                  }
                }
              })
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  transformDataComboBoxCliente(lista) {
    lista = lista.map((item) => {
      item.value = item.desc;
      item.label = item.desc;
      return item;
    });
    return lista;
  }

  async handleChangeSelect(item) {
    this.setState({ clienteSelecionado: item });
  }

  abrirDetalheCliente() {
    if (this.state.clienteSelecionado !== null) {
      this.props.history.push(
        `/cliente-detalhe?id=${this.state.clienteSelecionado._id}`
      );
    }
  }

  async loadCidadesCarteira() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/clientes/cidades-carteira`,
        this.props.parameters()
      )
      .then((response) => {
        let listaCidades = response.data.listaCidades;

        if (listaCidades.length) {
          listaCidades = listaCidades.map((item) => {
            item.label = item.cidadeFormatada;
            item.value = item.cidadeFormatada;
            return item;
          });
        }

        this.setState({ listaCidades });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadClientesCidade() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/clientes-cidade`,
        { cidade: this.state.cidadeselecionada.cidade },
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ listaClientesCidade: response.data.clientes });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Carteira de Clientes" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"carteira"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Carteira de clientes"
                  description="Avaliação de clientes atendidos no mês atual."
                /> */}

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div
                      className="form-group"
                      style={{ float: "left", minWidth: "450px" }}
                    >
                      <label>Cliente</label>
                      <div style={{ float: "left", width: "100%" }}>
                        <div style={{ width: "90%", float: "left" }}>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            loadOptions={(inputValue) =>
                              this.debouncedLoadOptions(inputValue)
                            }
                            value={this.state.clienteSelecionado}
                            onChange={(item) => this.handleChangeSelect(item)}
                            placeholder="Pesquise pela fantasia ou código"
                          />
                        </div>
                        <div
                          style={{
                            width: "9%",
                            float: "left",
                            fontSize: "22px",
                            marginLeft: "1%",
                            cursor: "pointer",
                          }}
                          onClick={(e) => this.abrirDetalheCliente()}
                        >
                          <i
                            className="fa fa-search-plus"
                            id="detalhar-cliente"
                          ></i>
                          <UncontrolledTooltip
                            placement="right"
                            target={`detalhar-cliente`}
                          >
                            Detalhar cliente
                          </UncontrolledTooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="recent-purchases-listing2"
                            className="table"
                          >
                            <thead>
                              <tr className="border-tab text-center">
                                <th
                                  className={`${
                                    this.state.abaAtiva === "atendidos"
                                      ? "item-tab-cliente-active"
                                      : "item-tab-cliente"
                                  }`}
                                >
                                  <a
                                    href="#"
                                    style={{ color: "inherit" }}
                                    onClick={(e) => this.toggleAba("atendidos")}
                                  >
                                    Clientes atendidos
                                  </a>
                                </th>
                                <th
                                  className={`${
                                    this.state.abaAtiva === "naoAtendidos"
                                      ? "item-tab-cliente-active"
                                      : "item-tab-cliente"
                                  }`}
                                >
                                  <a
                                    href="#"
                                    style={{ color: "inherit" }}
                                    onClick={(e) =>
                                      this.toggleAba("naoAtendidos")
                                    }
                                  >
                                    Clientes não atendidos
                                  </a>
                                </th>
                                <th
                                  className={`${
                                    this.state.abaAtiva === "criticos"
                                      ? "item-tab-cliente-active"
                                      : "item-tab-cliente"
                                  }`}
                                >
                                  <a
                                    href="#"
                                    style={{ color: "inherit" }}
                                    onClick={(e) => this.toggleAba("criticos")}
                                  >
                                    Clientes críticos
                                  </a>
                                </th>
                                <th
                                  className={`${
                                    this.state.abaAtiva === "clientesCidade"
                                      ? "item-tab-cliente-active"
                                      : "item-tab-cliente"
                                  }`}
                                >
                                  <a
                                    href="#"
                                    style={{ color: "inherit" }}
                                    onClick={(e) =>
                                      this.toggleAba("clientesCidade")
                                    }
                                  >
                                    Clientes por cidade
                                  </a>
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>

                        {this.state.abaAtiva === "atendidos" && (
                          <React.Fragment>
                            <div className="table-responsive">
                              <div className="mb-md-0 teste0">
                                Clientes que tiveram orçamentos ou pedidos
                                emitidos no mês atual.
                              </div>
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th className="text-right">N° Atend.</th>
                                    <th className="text-right">
                                      Último atend.
                                    </th>
                                    <th className="text-right">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.clientesAtendidos.map(
                                    (pedido, key) => (
                                      <tr key={key}>
                                        <td style={{ fontWeight: "bold" }}>
                                          <Link
                                            to={`/cliente-detalhe?id=${pedido.cliente._id}`}
                                            style={{
                                              color: "inherit",
                                              cursor: "pointer",
                                            }}
                                          >
                                            #{pedido.cliente.cod}
                                          </Link>
                                        </td>
                                        <td>
                                          {pedido.cliente.desc} <br />{" "}
                                          <span className="font-size-13 font-999">
                                            Pagamento em:{" "}
                                            {pedido.condPagto.desc} -{" "}
                                            {pedido.formaPagto.desc}
                                          </span>
                                        </td>
                                        <td className="text-right">
                                          {pedido.totalAtendimentos}
                                        </td>
                                        <td className="text-right">
                                          {moment(pedido.data).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </td>
                                        <td className="text-right">
                                          <Link
                                            to={`/cliente-detalhe?id=${pedido.cliente._id}`}
                                          >
                                            <i
                                              className="fa fa-search-plus font-000"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              id={`detalhar-cliente-${pedido.cliente._id}`}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`detalhar-cliente-${pedido.cliente._id}`}
                                            >
                                              Detalhar cliente
                                            </UncontrolledTooltip>
                                          </Link>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>

                            <div className="paginacao">
                              <Pagination
                                prevPageText={
                                  <i className="fa fa-angle-left" />
                                }
                                nextPageText={
                                  <i className="fa fa-angle-right" />
                                }
                                firstPageText={
                                  <i className="fa fa-angle-double-left" />
                                }
                                lastPageText={
                                  <i className="fa fa-angle-double-right" />
                                }
                                activePage={
                                  this.state.paginacaoClientesAtendidos.pagina
                                }
                                itemsCountPerPage={
                                  this.state.paginacaoClientesAtendidos.limite
                                }
                                totalItemsCount={
                                  this.state.totalizadorClientesAtendidos
                                }
                                onChange={(pagina) =>
                                  this.paginarAtendidos(pagina)
                                }
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div>
                          </React.Fragment>
                        )}

                        {this.state.abaAtiva === "naoAtendidos" && (
                          <React.Fragment>
                            <div className="table-responsive">
                              <div className="mb-md-0 teste0">
                                Clientes que não tiveram orçamentos ou pedidos
                                emitidos no mês atual, mas foram atendidos nos
                                ultimos 3 meses.
                              </div>

                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th className="text-right">N° Atend.</th>
                                    <th className="text-right">
                                      Último atend.
                                    </th>
                                    <th className="text-right">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.clientesNaoAtendidos.map(
                                    (pedido, key) => (
                                      <tr key={key}>
                                        <td style={{ fontWeight: "bold" }}>
                                          <Link
                                            to={`/cliente-detalhe?id=${pedido.cliente._id}`}
                                            style={{
                                              color: "inherit",
                                              cursor: "pointer",
                                            }}
                                          >
                                            #{pedido.cliente.codigo}
                                          </Link>
                                        </td>
                                        <td>
                                          {pedido.cliente.desc} <br />{" "}
                                          <span className="font-size-13 font-999">
                                            Pagamento em:{" "}
                                            {pedido.condPagto.desc} -{" "}
                                            {pedido.formaPagto.desc}
                                          </span>
                                        </td>
                                        <td className="text-right">
                                          {pedido.totalAtendimentos}
                                        </td>
                                        <td className="text-right">
                                          {moment(pedido.data).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </td>
                                        <td className="text-right">
                                          <Link
                                            to={`/cliente-detalhe?id=${pedido.cliente._id}`}
                                          >
                                            <i
                                              className="fa fa-search-plus font-000"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              id={`detalhar-cliente-${pedido.cliente._id}`}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`detalhar-cliente-${pedido.cliente._id}`}
                                            >
                                              Detalhar cliente
                                            </UncontrolledTooltip>
                                          </Link>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>

                            <div className="paginacao">
                              <Pagination
                                prevPageText={
                                  <i className="fa fa-angle-left" />
                                }
                                nextPageText={
                                  <i className="fa fa-angle-right" />
                                }
                                firstPageText={
                                  <i className="fa fa-angle-double-left" />
                                }
                                lastPageText={
                                  <i className="fa fa-angle-double-right" />
                                }
                                activePage={
                                  this.state.paginacaoClientesNaoAtendidos
                                    .pagina
                                }
                                itemsCountPerPage={
                                  this.state.paginacaoClientesNaoAtendidos
                                    .limite
                                }
                                totalItemsCount={
                                  this.state.totalizadorClientesNaoAtendidos
                                }
                                onChange={(pagina) =>
                                  this.paginarNaoAtendidos(pagina)
                                }
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div>
                          </React.Fragment>
                        )}

                        {this.state.abaAtiva === "criticos" && (
                          <React.Fragment>
                            <div className="table-responsive">
                              <div className="mb-md-0 teste0">
                                Clientes que não tiveram nenhum atendimento a
                                mais de 3 meses.
                              </div>

                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th className="text-right">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.clientesCriticos.map(
                                    (cliente, key) => (
                                      <tr key={key}>
                                        <td style={{ fontWeight: "bold" }}>
                                          <Link
                                            to={`/cliente-detalhe?id=${cliente._id}`}
                                            style={{
                                              color: "inherit",
                                              cursor: "pointer",
                                            }}
                                          >
                                            #{cliente.cod}
                                          </Link>
                                        </td>
                                        <td>{cliente.desc}</td>
                                        <td className="text-right">
                                          <Link
                                            to={`/cliente-detalhe?id=${cliente._id}`}
                                          >
                                            <i
                                              className="fa fa-search-plus font-000"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              id={`detalhar-cliente-${cliente._id}`}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`detalhar-cliente-${cliente._id}`}
                                            >
                                              Detalhar cliente
                                            </UncontrolledTooltip>
                                          </Link>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>

                            <div className="paginacao">
                              <Pagination
                                prevPageText={
                                  <i className="fa fa-angle-left" />
                                }
                                nextPageText={
                                  <i className="fa fa-angle-right" />
                                }
                                firstPageText={
                                  <i className="fa fa-angle-double-left" />
                                }
                                lastPageText={
                                  <i className="fa fa-angle-double-right" />
                                }
                                activePage={
                                  this.state.paginacaoClientesCriticos.pagina
                                }
                                itemsCountPerPage={
                                  this.state.paginacaoClientesCriticos.limite
                                }
                                totalItemsCount={
                                  this.state.totalizadorClientesCriticos
                                }
                                onChange={(pagina) =>
                                  this.paginarCriticos(pagina)
                                }
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div>
                          </React.Fragment>
                        )}

                        {this.state.abaAtiva === "clientesCidade" && (
                          <React.Fragment>
                            <div
                              className="col-md-6 grid-margin stretch-card"
                              ref={(node) => {
                                if (node) {
                                  node.style.setProperty(
                                    "padding",
                                    "0px",
                                    "important"
                                  );
                                }
                              }}
                            >
                              <div
                                className="form-group"
                                style={{ float: "left", minWidth: "450px" }}
                              >
                                <label>Filtrar por cidade</label>
                                <div style={{ float: "left", width: "100%" }}>
                                  <div style={{ width: "90%", float: "left" }}>
                                    <Select
                                      options={this.state.listaCidades}
                                      value={this.state.cidadeselecionada}
                                      onChange={(item) =>
                                        this.setState(
                                          { cidadeselecionada: item },
                                          () => {
                                            this.loadClientesCidade();
                                          }
                                        )
                                      }
                                      placeholder="Selecione"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="table-responsive">
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th className="text-right">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.listaClientesCidade.map(
                                    (cliente, key) => (
                                      <tr key={key}>
                                        <td style={{ fontWeight: "bold" }}>
                                          <Link
                                            to={`/cliente-detalhe?id=${cliente._id}`}
                                            style={{
                                              color: "inherit",
                                              cursor: "pointer",
                                            }}
                                          >
                                            #{cliente.cod}
                                          </Link>
                                        </td>
                                        <td>{cliente.desc}</td>
                                        <td className="text-right">
                                          <Link
                                            to={`/cliente-detalhe?id=${cliente._id}`}
                                            target={"_blank"}
                                          >
                                            <i
                                              className="fa fa-search-plus font-000"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              id={`detalhar-cliente-cidade-${cliente._id}`}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`detalhar-cliente-cidade-${cliente._id}`}
                                            >
                                              Detalhar cliente
                                            </UncontrolledTooltip>
                                          </Link>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* <div className="paginacao">
                              <Pagination
                                prevPageText={
                                  <i className="fa fa-angle-left" />
                                }
                                nextPageText={
                                  <i className="fa fa-angle-right" />
                                }
                                firstPageText={
                                  <i className="fa fa-angle-double-left" />
                                }
                                lastPageText={
                                  <i className="fa fa-angle-double-right" />
                                }
                                activePage={
                                  this.state.paginacaoClientesCriticos.pagina
                                }
                                itemsCountPerPage={
                                  this.state.paginacaoClientesCriticos.limite
                                }
                                totalItemsCount={
                                  this.state.totalizadorClientesCriticos
                                }
                                onChange={(pagina) =>
                                  this.paginarCriticos(pagina)
                                }
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div> */}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Carteira;
